import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Configuration for development
    gamesCasino, // Casino games configuration
    profile, // User profile configuration
    providersCasino, // Casino providers configuration
} from 'config/config'; // Importing various configurations

/**
 * Class representing a view for machine type product management.
 */
export default class tableMachineTypeProductView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        var list1 = {
            view: 'dbllist', // Double list view
            id: 'dbllist', // ID for the double list
            list: {
                height: 0, // Height of the list
                scroll: true, // Enable scrolling
            },
            labelLeft: _('Tipo producto no agregados'), // Left label for unadded products
            labelRight: _('Tipo producto Agregados'), // Right label for added products
            data: [], // Initial data for the list
        };
        return {
            view: 'form', // Form view
            id: 'f1', // Form ID
            rows: [
                {
                    view: 'forminput', // Input field in the form
                    name: 'access', // Name of the input
                    body: list1, // Body of the input
                    labelWidth: 140, // Width of the label
                    labelAlign: 'right', // Label alignment
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        var values = ''; // Variable to store values
        const cur_user = this.getParam('user', true); // Current user parameter
        this.on(this.app, 'machineTypeProducts:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for API request
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object filters
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format dateFrom
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format dateTo
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $$('dbllist').$$('left').clearAll(); // Clear left list
            $$('dbllist').setValue([]); // Reset selected values
            webix
                .ajax() // AJAX request to fetch data
                .get(
                    devConfig.geturlApi() + 'MachineTypeProduct/GetGroupMachineTypeProduct', // API endpoint
                    string1, // Query string
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error handler
                            webix.message('Error! '); // Show error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success handler
                            var data = JSON.parse(text); // Parse response data
                            if (!data.HasError) {
                                // Check for errors
                                $$('dbllist').$$('left').clearAll(); // Clear left list
                                $$('dbllist').setValue([]); // Reset selected values
                                $$('dbllist').parse(
                                    // Parse new data into the list
                                    data.Data.ExcludedTypeProductList,
                                );
                                $$('dbllist').setValue(
                                    // Set included products
                                    data.Data.IncludedTypeProductList,
                                );
                                values = data.Data.IncludedTypeProductList; // Store included products
                            } else {
                                webix.message('Error! '); // Show error message
                            }
                        },
                    },
                );
        });
        $$('dbllist').attachEvent('onChange', function (id, e, node) {
            // Event listener for changes in the double list
            var array1 = values.split(','); // Split current values into an array
            var array2 = $$('dbllist').getValue().split(','); // Get new values from the list
            var arrayAgregados = []; // Array for added products
            var arrayEliminados = []; // Array for removed products
            array2.forEach(function (obj) {
                // Iterate through new values
                var found = array1.find(function (element) {
                    // Check if the value exists in the old array
                    return element == obj;
                });
                if (found != undefined) {
                    // If found, do nothing
                } else {
                    arrayAgregados.push(obj); // Add to added products
                }
            });
            array1.forEach(function (obj) {
                // Iterate through old values
                var found = array2.find(function (element) {
                    // Check if the value exists in the new array
                    return element == obj;
                });
                if (found == undefined) {
                    // If not found, add to removed products
                    arrayEliminados.push(obj);
                } else {
                }
            });
            values = $$('dbllist').getValue(); // Update stored values
            webix
                .ajax() // AJAX request to save changes
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .post(
                    devConfig.geturlApi() + 'MachineProviders/SaveGroupMachineTypeProduct', // API endpoint
                    '{"IdMachine":"' +
                        cur_user +
                        '","IncludedTypeProductList":"' +
                        arrayAgregados +
                        '","ExcludedTypeProductList":"' +
                        arrayEliminados +
                        '"}', // Request body
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error handler
                            webix.message(_('Error! ')); // Show error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success handler
                            var data = JSON.parse(text); // Parse response data
                            if (!data.HasError) {
                                // Check for errors
                                webix.message(
                                    // Show success message
                                    _('Tipo producto Máquina Editado'),
                                );
                            } else {
                                webix.message(_('Error! ')); // Show error message
                            }
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
